export default __webpack_public_path__ + "static/media/check.f6948c5c.svg";